import { axios } from "lib/axios";

export const getProfile = () => {
    return axios.get('/profile');
}

// User

export const login = (email, password) => {
    return axios.post('/login', { username_: email, password_: password });
};

export const signUp = (email, confirmation_url) => {
    const params = { email, confirmation_url };

    return axios.post('/registration', params);
};

export const finishRegistration = (params) => {
    return axios.post('/registration_confirm', params);
};

export const resetPasswordRequest = (params) => {
    return axios.post('/reset_password_request', params);
};

export const resetPassword = (params) => {
    return axios.post('/reset_password', params);
};

export const getReport = (reportUrl) => {
    return axios.get(reportUrl);
}

export const getReportSettings = () => {
    return axios.get('/report_settings');
}

export const patchDomainSettings = (keys) => {
    return axios.patch('/domain_settings', { openai_keys: keys });
}

// Admin

export const adminLogin = (email, password) => {
    return axios.post('/admin/login', { username_: email, password_: password });
};

export const getDomains = () => {
    return axios.get('/admin/domain');
}

export const addDomain = (params) => {
    return axios.post('/admin/domain', params)
}

export const switchDomainStatus = (id, params) => {
    return axios.patch(`/admin/domain/${id}`, params)
}

export const getGeneralSettings = () => {
    return axios.get('/admin/general_settings');
}

export const updateGeneralSettings = (id, value) => {
    return axios.patch(`/admin/general_settings/${id}`, { value });
}

export const getUsers = () => {
    return axios.get('/admin/user');
}

export const updateUser = (id, isAdmin, isEnabled = true) => {
    return axios.patch(`/admin/user/${id}`, { admin: isAdmin, enabled: isEnabled });
}
